<template>
  <section>
    <div>
      <div class="pb-2">
        <b>ข้อมูลการจองที่ AI วิเคราะห์ได้</b>
      </div>
      <ul class="ai-list">
        <li>
          {{ response.service.name_th }}
        </li>
        <li v-if="response.params.work_hour">
          จำนวนชม. {{ response.params.work_hour }} ชม.
        </li>
        <li v-if="response.params.service_date || response.params.service_dates">
          วันที่ใช้บริการ:
          <template v-if="response.params.service_dates">
            <span>{{ response.params.service_dates.length }} วัน</span>
            <div :key="index" v-for="(serviceDate, index) in response.params.service_dates">
              <span>- {{ serviceDate | prettyOnlyDate }}</span>
              <span v-if="response.params.service_time && response.params.service_time !== '00:00:00'">
                {{ response.params.service_time }}
              </span>
            </div>
          </template>
          <template v-else>
            <span v-if="response.params.service_date">
              <span>{{ response.params.service_date | prettyOnlyDate }}</span>
              <span v-if="response.params.service_time && response.params.service_time !== '00:00:00'">
                {{ response.params.service_time }}
              </span>
            </span>
          </template>
        </li>
        <li v-if="response.professional">
          แม่บ้านที่เคยใช้บริการ ID: {{ response.professional.id }} {{ response.professional.firstname }} {{ response.professional.lastname }}
        </li>
      </ul>
      <div v-if="response.pre_bookings">
        ลูกค้ามีรายการ Pre-Booking
        <ul class="ai-list">
          <li :key="index" v-for="(preBooking, index) in response.pre_bookings">
            <a :href="`https://admin-test.beneat.co/pre-bookings?id=${preBooking.id}`" target="_blank">
              PB #{{ preBooking.id }}
            </a>
          </li>
        </ul>
      </div>
      <div>
        <div class="pb-2">
          <b>ข้อมูลที่ยังขาด</b>
        </div>
        <div class="form-group row" v-if="canSelectTime">
          <label for="selectPlace" class="col-sm-3 col-form-label">เวลา</label>
          <div class="col-sm-9">
            <select
              id="selectPlace"
              class="form-control input-sm"
              v-model="response.params.service_time"
            >
              <option :value="null">เลือกเวลา</option>
              <option
                :key="index"
                :value="time"
                v-for="(time, index) in strTimes"
              >
                {{ time }}
              </option>
            </select>
          </div>
        </div>
        <div class="form-group row" v-if="canSelectWorkHours">
          <label for="selectPlace" class="col-sm-3 col-form-label">จำนวนชม.</label>
          <div class="col-sm-9">
            <select
              id="selectPlace"
              class="form-control input-sm"
              v-model="response.params.work_hour"
            >
              <option :value="null">เลือกจำนวนชม.</option>
              <option
                :key="index"
                :value="workHour"
                v-for="(workHour, index) in workHours"
              >
                {{ workHour | prettyWorkHours }}
              </option>
            </select>
          </div>
        </div>
        <div class="form-group row" v-if="response.user_places">
          <label for="selectPlace" class="col-sm-3 col-form-label"
            >สถานที่</label
          >
          <div class="col-sm-9">
            <select
              id="selectPlace"
              class="form-control input-sm"
              v-model="selectedUserPlace"
            >
              <option :value="null">เลือกที่พัก</option>
              <option
                :key="index"
                :value="userPlace"
                v-for="(userPlace, index) in response.user_places"
              >
                {{ userPlace.place_name }}
              </option>
            </select>
          </div>
        </div>
        <div class="card shadow-sm mb-3" v-if="selectedUserPlace">
          <div class="card-body p-3">
            <div>ที่อยู่: {{ selectedUserPlace.address }}</div>
            <div>ประเภท: {{ selectedUserPlace.place_size.name_th }}</div>
            <div>จังหวัด: {{ selectedUserPlace.province.name_th }}</div>
          </div>
        </div>
        <div class="form-group row" v-if="response.child_services">
          <label for="selectChildService" class="col-sm-3 col-form-label">บริการ</label>
          <div class="col-sm-9">
            <select
              id="selectChildService"
              class="form-control input-sm"
              v-model="selectedChildService"
            >
              <option :value="null">เลือกประเภทบริการ</option>
              <option
                :key="index"
                :value="childService"
                v-for="(childService, index) in response.child_services"
              >
                {{ childService.name_th }} <span v-if="childService.province">{{ childService.province.name_th }}</span>
              </option>
            </select>
          </div>
        </div>
        <div class="form-group row">
          <label for="professionals" class="col-sm-3 col-form-label">แม่บ้าน</label>
          <div class="col-sm-9">
            <v-select
              id="professionals"
              placeholder="ไม่ระบุผู้ให้บริการ"
              name="professionals"
              label="name"
              :filterable="false"
              :options="professionals"
              v-model="selectedProfessional"
              @search="onSearchProfessionals"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
              </template>
              <template slot="no-options">
                กรุณาระบุรหัสหรือชื่อคุณแม่บ้าน
              </template>
              <template slot="option" slot-scope="option">
                <div class="d-center">
                  <img
                    class="rounded-circle"
                    :src="option.picture_url || require('@/assets/no_photos.png')"
                    width="35"
                  />&nbsp;
                  <span class="text-dark">{{
                    'ID:' + option.id + ' ' + option.full_name
                  }}</span>
                </div>
              </template>
              <template slot="selected-option" slot-scope="option">
                <div class="selected d-center" style="font-size: 11px">
                  <img
                    class="rounded-circle"
                    :src="
                      option.picture_url || require('@/assets/no_photos.png')
                    "
                    width="35"
                  />&nbsp;
                  <span class="text-dark">{{
                    'ID:' + option.id + ' ' + option.full_name
                  }}</span>
                </div>
              </template>
            </v-select>
          </div>
        </div>
      </div>
    </div>
    <button class="btn btn-block btn-info btn-sm mt-2" v-if="canBookService()" @click="submitData()">
      สร้างรายการจอง
    </button>
  </section>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  props: {
    response: Object
  },
  data () {
    return {
      canSelectWorkHours: false,
      canSelectTime: false,
      strTimes: [
        '00:00', '00:30', '01:00', '01:30', '02:00', '02:30', '03:00', '03:30', '04:00', '04:30', '05:00', '05:30',
        '06:00', '06:30', '07:00', '07:30', '08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30',
        '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30',
        '18:00', '18:30', '19:00', '19:30', '20:00', '20:30', '21:00', '22:30', '23:00', '23:30'
      ],
      workHours: [null, 2.0, 2.5, 3.0, 3.5, 4.0, 4.5, 6.0, 8.0],
      keyword: null,
      selectedUserPlace: null,
      selectedProfessional: null,
      selectedChildService: null
    }
  },
  computed: {
    ...mapState('conversation', ['customer']),
    ...mapState('professional', ['professionals'])
  },
  watch: {
    // professionals () {
    //   if (this.professionals && this.professionals.length) {
    //     this.selectedProfessional = this.professionals[0]
    //   }
    // },
    selectedChildService () {
      if (this.selectedChildService) {
        this.response.params.service_id = this.selectedChildService.id
        if (this.selectedChildService.duration) {
          this.response.params.work_hour = this.selectedChildService.duration
        }
      }
    }
  },
  methods: {
    ...mapActions('professional', ['searchProfessionals']),
    formValidation () {
      let isValid = true
      if (!this.selectedUserPlace) {
        isValid = false
      }
      return isValid
    },
    objectToQueryString (obj) {
      const params = new URLSearchParams()
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          params.append(key, obj[key])
        }
      }
      return params.toString()
    },
    submitData () {
      let params = Object.assign({}, this.response.params)
      params.auto_fill = 1
      if (this.customer) {
        const objCustomer = this.customer.customer
        params.user_id = objCustomer.id
        params.email = objCustomer.email
      }
      if (this.selectedUserPlace) {
        params.user_place_id = this.selectedUserPlace.id
      }
      if (this.selectedProfessional) {
        params.selected_professional_id = this.selectedProfessional.id
      }
      const queryParams = this.objectToQueryString(params)
      // console.log('check queryParams', queryParams)
      let url = `https://admin-test.beneat.co/order/create-multiple?${queryParams}`
      if (process.env.NODE_ENV !== 'production') {
        url = `http://localhost:8090/order/create-multiple?${queryParams}`
      }
      window.open(url, '_blank')
    },
    canBookService () {
      let result = false
      if (this.response && this.response.user_places && this.response.user_places.length) {
        result = true
      }
      return result
    },
    async onSearchProfessionals (search, loading) {
      loading(true)
      if (!search.trim()) {
        loading(false)
      }
      await this.searchProfessionals(search)
      loading(false)
    }
  },
  mounted () {
    this.$store.commit('professional/SET_PROFESSIONALS', [])
    const params = this.response.params
    if ((!params.service_time || (params.service_time && params.service_time === '00:00:00'))) {
      this.canSelectTime = true
      this.response.params.service_time = null
    }
  }
}
</script>
